import type { CSSProperties } from 'react'
import type { LucideIcon } from 'lucide-react'
import {
  ArrowRight,
  Archive,
  Banknote,
  Box,
  CalendarCheck2,
  CalendarDays,
  Camera,
  Check,
  CheckCircle2,
  CircleDot,
  CreditCard,
  ExternalLink,
  FilePenLine,
  Hourglass,
  LayoutDashboard,
  Mail,
  Megaphone,
  Menu,
  MessageSquare,
  Palette,
  Plus,
  Rocket,
  Scissors,
  Search,
  Send,
  Shield,
  Store,
  Star,
  Target,
  UserPlus,
  Users,
  Video,
  Zap,
  Lock,
  GripVertical,
  TriangleAlert,
} from 'lucide-react'

const ICONS = {
  add: Plus,
  archive: Archive,
  arrow_forward: ArrowRight,
  bolt: Zap,
  calendar_month: CalendarDays,
  campaign: Megaphone,
  check: Check,
  check_circle: CheckCircle2,
  content_cut: Scissors,
  credit_card: CreditCard,
  dashboard: LayoutDashboard,
  drag_indicator: GripVertical,
  edit_note: FilePenLine,
  electric_bolt: Zap,
  event_available: CalendarCheck2,
  groups: Users,
  hourglass_top: Hourglass,
  lock: Lock,
  mail: Mail,
  menu: Menu,
  open_in_new: ExternalLink,
  palette: Palette,
  payments: Banknote,
  person_add: UserPlus,
  photo_camera: Camera,
  point_of_sale: Store,
  radio_button_checked: CircleDot,
  rocket_launch: Rocket,
  search: Search,
  send: Send,
  shield: Shield,
  sms: MessageSquare,
  star: Star,
  target: Target,
  videocam: Video,
  view_in_ar: Box,
  warning: TriangleAlert,
} as const satisfies Record<string, LucideIcon>

export type LucideGlyphName = keyof typeof ICONS

interface LucideGlyphProps {
  name: LucideGlyphName
  size?: number
  strokeWidth?: number
  className?: string
  color?: string
  style?: CSSProperties
  'aria-hidden'?: boolean
}

export default function LucideGlyph({
  name,
  size = 16,
  strokeWidth = 2,
  className,
  color,
  style,
  'aria-hidden': ariaHidden,
}: LucideGlyphProps) {
  const Icon = ICONS[name]
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      color={color}
      style={style}
      aria-hidden={ariaHidden}
    />
  )
}
